export default "__VITE_ASSET__ClfmES3G__"